<div class="schedule" role="region" aria-label="Employee schedule">
    <span class="sr-only" aria-live="polite" aria-atomic="true">{{ periodLabel }}</span>
    <div class="top">
        <h2 appLocalizationPopupDirective [localizationCode]="'Schedule'" id="schedule-heading">{{ 'Schedule' | translate: {Default: "Schedule"} }}</h2>

        <div class="buttons" role="group" aria-label="Navigate schedule">
            <button mat-raised-button appPreventDoubleClick (throttledClick)="dateChange('back')" aria-label="Previous period">
                <mat-icon class="material-icons-outlined" aria-hidden="true">arrow_back_ios</mat-icon>
            </button>
            <button mat-raised-button appPreventDoubleClick (throttledClick)="dateChange('forward')" aria-label="Next period">
                <mat-icon class="material-icons-outlined" aria-hidden="true">arrow_forward_ios</mat-icon>
            </button>
        </div>
    </div>

    
    <ng-container *ngIf="isLoading; else loaded">
        <div class="loading" role="status" aria-label="Loading schedule" aria-busy="true">
            <ngx-skeleton-loader
                count="5"
                [theme]="{ 
                    'height.px': 50,
                    'background-color': 'white',
                    border: '1px solid white'
                }"
            ></ngx-skeleton-loader>
        </div>
    </ng-container>
    <ng-template #loaded>
        <div
            class="day"
            [ngClass]="{ 'currentDay': date.isToday }"
            *ngFor="let date of datesArray"
            role="listitem"
            tabindex="0"
            [attr.aria-label]="getDayAriaLabel(date)"
        >
            <div class="top">
                <div class="date">
                    {{ date.monthAndYear }}
                </div>

                <span *ngIf="date.isToday" class="dot" aria-hidden="true"></span>
            </div>
    
            <mat-chip-set
                class="mat-chip-list-stacked"
                [attr.aria-label]="'Events for ' + date.monthAndYear"
            >
                <mat-chip
                    class="event"
                    [ngClass]="event.description"
                    *ngFor="let event of date.events"
                    selected
                    [attr.aria-label]="(event.description === 'StatutoryHoliday' ? 'Public holiday: ' : event.description === 'Leave' ? 'Leave: ' : event.description === 'Work' ? 'Work: ' : '') + event.title"
                >
                    <mat-icon *ngIf="event.description === 'StatutoryHoliday'" class="material-icons-outlined public-holiday" aria-hidden="true">celebration</mat-icon>
                    <mat-icon *ngIf="event.description === 'Leave'" class="material-icons-outlined absence" aria-hidden="true">date_range</mat-icon>
                    <mat-icon *ngIf="event.description === 'Work'" class="material-icons-outlined company-event" aria-hidden="true">work</mat-icon>
                    
                    {{event.title}}
                </mat-chip>
            </mat-chip-set>
        </div>
    </ng-template>
</div>